import { render, staticRenderFns } from "./CeoDirectory.vue?vue&type=template&id=23ede44b&scoped=true&"
import script from "./CeoDirectory.vue?vue&type=script&lang=js&"
export * from "./CeoDirectory.vue?vue&type=script&lang=js&"
import style0 from "./CeoDirectory.vue?vue&type=style&index=0&id=23ede44b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ede44b",
  null
  
)

export default component.exports